module.exports = __webpack_public_path__ + "img/bringIn.e09863ae.svg";